export const Home = () => {
  return <main>{/* no proper content here rn */}</main>;
};
